import { getCmsApiBase } from "../api/services/authService";

const MCP_PATH = "/mcp";

/** Resolve the SAMI CMS embedded MCP Streamable HTTP endpoint for the current environment. */
export function getMcpEndpointUrl(): string {
  const base = getCmsApiBase().replace(/\/$/, "");
  const path = `${base}${MCP_PATH}`;
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://your-cms-host";
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Cursor `.cursor/mcp.json` snippet for PAT-authenticated MCP access. */
export function buildCursorMcpJson(patToken?: string): string {
  const token = patToken?.trim() || "pat-<your-token>";
  return JSON.stringify(
    {
      mcpServers: {
        "sami-cms": {
          url: getMcpEndpointUrl(),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      },
    },
    null,
    2,
  );
}
